"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AmountChooserInfoPanel = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactIntl = require("react-intl");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var ReactIntl = require("react-intl");

var FormattedNumber = ReactIntl.FormattedNumber;

var _require = require("react-bootstrap"),
    Well = _require.Well;

var _require2 = require("./util"),
    calculatePiecesFromWeight = _require2.calculatePiecesFromWeight,
    preservePrecision = _require2.preservePrecision; // Default duration in ms to temporarily display the info panel


var DEFAULT_TIMEOUT_STANDARD = 3000; // Default display duration in ms after not showing it permanently anymore
// (avoids flickering when quickly going from permanent to timed display,
// e.g., when clicking increase amount button while focus inside input field)

var DEFAULT_TIMEOUT_SHORT = 200;

var getWeightFromProps = function getWeightFromProps(totalWeight, numberOfPieces, weightPerPieceValue) {
  if (numberOfPieces === undefined) {
    return totalWeight;
  } // number of pieces prop has higher priority than weight prop


  var newWeight = preservePrecision(numberOfPieces, weightPerPieceValue, numberOfPieces * weightPerPieceValue);
  return newWeight || 0;
};

/**
 * Component that renders the amount chooser info panel for
 articles with a weight per piece.
 */
var AmountChooserInfoPanel = function AmountChooserInfoPanel(_ref) {
  var showTimedInitially = _ref.showTimedInitially,
      showPermanently = _ref.showPermanently,
      showIfZeroAmount = _ref.showIfZeroAmount,
      timeoutShort = _ref.timeoutShort,
      timeoutStandard = _ref.timeoutStandard,
      totalWeight = _ref.totalWeight,
      numberOfPieces = _ref.numberOfPieces,
      weightPerPieceValue = _ref.weightPerPieceValue,
      totalPrice = _ref.totalPrice,
      currency = _ref.currency,
      isPriceLoading = _ref.isPriceLoading,
      className = _ref.className;

  var _useState = (0, _react.useState)(getWeightFromProps(totalWeight, numberOfPieces, weightPerPieceValue)),
      _useState2 = _slicedToArray(_useState, 2),
      currentWeight = _useState2[0],
      setCurrentWeight = _useState2[1];

  var _useState3 = (0, _react.useState)({
    state: "HIDDEN"
  }),
      _useState4 = _slicedToArray(_useState3, 2),
      visibility = _useState4[0],
      setVisibility = _useState4[1];

  visibility;

  var changeVisibility = function changeVisibility(newVisibility) {
    if (visibility.timeoutId) {
      clearTimeout(visibility.timeoutId);
    }

    setVisibility(newVisibility);
  };

  _react["default"].useEffect(function () {
    if (showTimedInitially) {
      setVisibility({
        state: "TIMED",
        timeoutId: setTimeout(function () {
          setVisibility({
            state: "HIDDEN"
          });
        }, timeoutStandard || DEFAULT_TIMEOUT_STANDARD)
      });
    }
  }, [setVisibility]);

  _react["default"].useEffect(function () {
    var newWeight = getWeightFromProps(totalWeight, numberOfPieces, weightPerPieceValue);
    var didWeightChange = currentWeight !== newWeight;

    if (didWeightChange) {
      setCurrentWeight(newWeight);
    }

    if (!showIfZeroAmount && newWeight === 0) {
      return changeVisibility({
        state: "HIDDEN"
      });
    }

    if (showPermanently && visibility.state !== "PERMANENT") {
      return changeVisibility({
        state: "PERMANENT"
      });
    }

    if (!showPermanently && (visibility.state === "PERMANENT" || didWeightChange)) {
      var timeout = didWeightChange ? timeoutStandard || DEFAULT_TIMEOUT_STANDARD : timeoutShort || DEFAULT_TIMEOUT_SHORT;
      changeVisibility({
        state: "TIMED",
        timeoutId: setTimeout(function () {
          setVisibility({
            state: "HIDDEN"
          });
        }, timeout)
      });
    }
  }, [totalWeight, numberOfPieces, weightPerPieceValue, showIfZeroAmount, showPermanently, setCurrentWeight]);

  if (visibility.state === "HIDDEN") {
    return null;
  }

  var piecesFromWeight = calculatePiecesFromWeight(currentWeight, weightPerPieceValue);

  var piecesString = /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "ORC_X_PIECES",
    values: {
      x: piecesFromWeight
    }
  });

  var weightString = currentWeight ? /*#__PURE__*/_react["default"].createElement("span", {
    "data-selenium": "test-amountchooser-infopanel-weight"
  }, /*#__PURE__*/_react["default"].createElement(FormattedNumber, {
    value: currentWeight,
    format: "decimal"
  }), " ", /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "ORC_KG"
  })) : null;
  var priceString = !isPriceLoading && totalPrice && currency ? /*#__PURE__*/_react["default"].createElement(FormattedNumber, {
    value: totalPrice,
    format: "currency",
    currency: currency
  }) : /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement("i", {
    className: "icon-spinner",
    "data-selenium": "test-amountchooser-infopanel-price-spinner"
  }));
  var baseClassName = "mfcss_amountchooser-infopanel mfcss_amountchooser-infopanel--absoluteposition";
  var fullClassName = className ? baseClassName + " " + className : baseClassName;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: fullClassName,
    "data-selenium": "test-amountchooser-infopanel"
  }, /*#__PURE__*/_react["default"].createElement(Well, {
    className: "well-sm well-info background-info"
  }, piecesString, weightString, priceString));
};

exports.AmountChooserInfoPanel = AmountChooserInfoPanel;